import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentryIfConsented } from './components/CookieConsent'
import './index.css'
import App from './App.tsx'

// Only initialize Sentry if user previously consented
initSentryIfConsented()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
